function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.25583 3.42857H8.83722V16.5714H3.25583V3.42857Z",
  fill: "#562024"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8333 3.33374H16.6666V6.66708H10.8333V3.33374ZM10.8333 6.66708H16.6666V13.3338H13.7209H10.8333V6.66708ZM16.6666 13.3338H10.8333V16.6671H16.6666V13.3338Z",
  fill: "#959595"
});

var SvgIconOrderBookSell = function SvgIconOrderBookSell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconOrderBookSell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconOrderBookSell.51607bbc.svg";
export { ForwardRef as ReactComponent };